// Copyright (c) 2026 Dyna Robotics, Inc. All rights reserved.
// Dyna Robotics Proprietary and Confidential.
// Unauthorized copying, use, or distribution is prohibited.
// SPDX-License-Identifier: LicenseRef-Dyna-Internal

/**
 * Reading the CSRF cookie (design doc §12.1.1).
 *
 * The session cookie is `HttpOnly` and invisible here by design. The CSRF cookie is not,
 * and that is deliberate: the double-submit scheme works precisely because this page can
 * read it and a cross-site page cannot.
 */

export const CSRF_COOKIE = "cybertron_csrf";

export function readCookie(name: string): string | null {
  const prefix = `${name}=`;
  for (const part of document.cookie.split(";")) {
    const trimmed = part.trim();
    if (trimmed.startsWith(prefix)) return decodeURIComponent(trimmed.slice(prefix.length));
  }
  return null;
}
